
import StateMachine from 'react-simple-state/dist';
//import SessionCookie from './Utils/SessionCookie.js';

const appState = new StateMachine();


/**
 * 
 * 
 */

function WebSocketClient() {
  this.enpointUrl = '';
  this.counter = 1;
  this.connectedCounter = 0;
  this.needsCredsCounter = 0;
  this.needsTokenCounter = 0;
  this.resetCalledCounter = 0;
  this.resetCounter = 1;
  this.quitReConnectingCount = 6;
  this.socketOpened = false;
  this.pingTimer = null;
  this.reConnectTimer = null;
  this.nextPingTime = 0;
  this.wsPingstarted = false;
  this.scoketListener = null;
  
  // Before sending token or interacting any way with server- wait 
  // for first message from server after websocket is opened
  this.firstMessageReceived = false;
  this.firstMessageTokenOrCredentials = ""; // NEEDS_CREDENTIALS or NEEDS_TOKEN 
  this.lastTokenOrCredentials = ""; // NEEDS_CREDENTIALS or NEEDS_TOKEN 
  this.firstMessageWaitTimer = null;
}


WebSocketClient.prototype.init = function ( emitter ) {
  this.nextPingTime = Math.floor(Date.now() / 1000) + 30;
  this.emitter = emitter;
  // this.eventProcessor = eventProcessor;
  this.initRealWebSocket();
};


WebSocketClient.prototype.setEndpointUrl = function ( url ) {
  this.enpointUrl = url;
};


WebSocketClient.prototype.setListener = function ( listener ) {
  this.scoketListener = listener;
};


/**
 * For testing with real WS
 * 
 */
WebSocketClient.prototype.initRealWebSocket = function () {
  // console.log('Init WebSocket');
  var that = this;
  
  if(this.reConnectTimer ){
    clearTimeout( this.reConnectTimer );
  }

  // if user is running mozilla then use it's built-in WebSocket
  window.WebSocket = window.WebSocket || window.MozWebSocket;

  /*
  var sessionCookie = new SessionCookie();
  const token = sessionCookie.readCookieValue("app-auth-token");
  
  let resetSessionCookie = '?reset';
  if ( token ) {
    resetSessionCookie = '';
  }
  */
  let resetSessionCookie = "";

  this.connection = new WebSocket( this.enpointUrl + resetSessionCookie );
  
  this.connection.onopen = function () {
    that.socketOpened = true;
    that.resetCounter = 0;
    that.connectedCounter = that.connectedCounter + 1;
    appState.evoke('connection-state', { connected: true });
    console.log('WS CONNECTION OPENED');
    
    // before continue- wait first message from server. 
    that.firstMessageReceived = false;
    that.firstMessageTokenOrCredentials = "";
    that.pollFirstServerMessage();
  };

  this.connection.onclose = function ( closeEvent ) {
    that.socketOpened = false;
    console.log('WS CONNECTION CLOSED');
    console.log( closeEvent );

    // close without re-connecting
    if( closeEvent.code === 4999 || closeEvent.code === "4999" ) {
      appState.evoke('connection-state', { connected: false, wsClosedIntentionally : true });
      return;
    }

    that.resetCounter = that.resetCounter + 1;
    // console.log( "resetCounter: " + that.resetCounter );

    if( that.resetCounter > that.quitReConnectingCount ){
      // Stop reconnecting. Let app know that connection is now gone. 
      appState.evoke('connection-state', { connected: false, wsStoppedConnecting : true });
      return;
    }

    appState.evoke('connection-state', { connected: false, reConnecting : true });
    
    that.reConnectTimer = setTimeout(function () {
      that.connection = null;
      that.initRealWebSocket();
    }, 100);
  };

  this.connection.onerror = function (error) {
    appState.evoke('connection-state', { connected: false });
    that.socketOpened = false;
    //console.log('WS CONNECTION ERROR : ' + error);
  };

  this.connection.onmessage = function (message) {
    var jsonin = null;

    try {
      jsonin = JSON.parse(message.data);
    } catch (e) {
      console.log('This doesn\'t look like a valid JSON: ' + e.message, message.data);
      return;
    }

    if( !that.firstMessageReceived && typeof message.data !== "undefined" ){
      // is first message NEEDS_CREDENTIALS or TOKEN
      // simple test which was sent by server
      
      if( message.data.indexOf("NEEDS_CREDENTIALS") > -1 ){
        that.firstMessageTokenOrCredentials = "NEEDS_CREDENTIALS";
        that.needsCredsCounter = that.needsCredsCounter + 1;
      }

      if( message.data.indexOf("NEEDS_TOKEN") > -1 ){
        that.firstMessageTokenOrCredentials = "NEEDS_TOKEN";
        that.needsTokenCounter = that.needsTokenCounter + 1;
      }
    }

    that.firstMessageReceived = true;

    if( typeof message.data !== "undefined" ){
      if( message.data.indexOf("NEEDS_CREDENTIALS") > -1 ){
        that.lastTokenOrCredentials = "NEEDS_CREDENTIALS";
      }
      if( message.data.indexOf("NEEDS_TOKEN") > -1 ){
        that.lastTokenOrCredentials = "NEEDS_TOKEN";
      }
    }

    that.emitter.emit( 'ServerCommunicationInRaw', {
      'conponent' : 'WebSocketClient',
      'rawJson' : jsonin
    } );

    //that.this.scoketListener.handleIncomingJson( jsonin );
    //that.eventProcessor.handleServerEvent('success', jsonin);
  };

};


/**
 * Keep socket open by sending pings
 * 
 */
WebSocketClient.prototype.initRealWebSocketPing = function () {
  var secondsBetweenPings = 45;
  this.wsPingstarted = true;
  var that = this;
  var test = Math.floor(Date.now() / 1000);

  if (test > this.nextPingTime  && this.socketOpened ) {
    this.nextPingTime = Math.floor(Date.now() / 1000) + secondsBetweenPings;
    this.connection.send(JSON.stringify( {
        "resourceType": "Bundle"
    } ));
  }

  this.pingTimer = setTimeout(function () { that.initRealWebSocketPing(); }, 3000);
}


/**
 * 
 */
WebSocketClient.prototype.isFirstMessageReceived = function () {
  return this.firstMessageReceived;
}


/**
 * Dont send token before server responses
 * NEEDS_CREDENTIALS or NEEDS_TOKEN 
 */
WebSocketClient.prototype.pollFirstServerMessage = function () {
  var that = this;

  if( !this.firstMessageReceived ){
    if( this.firstMessageWaitTimer !== null ){
      clearTimeout( this.firstMessageWaitTimer );
    }
    this.firstMessageWaitTimer = setTimeout(function () { that.pollFirstServerMessage(); }, 100 );
    return;
  }

  this.firstMessageWaitTimer = null;

  if (!that.wsPingstarted) {
    that.initRealWebSocketPing();
  }
  
  /*
  var sessionCookie = new SessionCookie();

  const token = sessionCookie.readCookieValue("app-auth-token");

  if (token) {
    var tokenBundle =
    {
      "resourceType": "Bundle",
      "type": "batch",
      "entry": [
        {
          "resource": {
            "resourceType": "Person",
            "identifier": [
              {
                "system": "https://documental.abtram.eu/fhir/namingsystem/session/token",
                "value": token
              }
            ],
            "managingOrganization": {
              "reference": "Organization/haigla"
            }
          },
          "request": {
            "method": "POST",
            "url": "Person"
          }
        }
      ]
    }

    that.connection.send(JSON.stringify(tokenBundle));

  }
  */

}


WebSocketClient.prototype.resetConnection = function () {
  var that = this;
  this.resetCalledCounter = this.resetCalledCounter + 1;

  // do we need to send some bundle before? 
  if( this.pingTimer ){
    clearTimeout(this.pingTimer);
  }
  if(this.reConnectTimer ){
    clearTimeout( this.reConnectTimer );
  }
  
  this.connection.close( 1000 );

  this.reConnectTimer = setTimeout(function () {
    that.connection = null;
    that.initRealWebSocket();
  }, 1000);

}

WebSocketClient.prototype.closeConnection = function () {
  var that = this;

  // do we need to send some bundle before? 
  if( this.pingTimer ){
    clearTimeout(this.pingTimer);
  }

  if(this.reConnectTimer ){
    clearTimeout( this.reConnectTimer );
  }
  
  this.connection.close( 4999 );
}


/**
 * 
 * 
 * @return boolean
 */
WebSocketClient.prototype.sendBundle = function (bundle) {
  var res = bundle.entry[0].resource;
  var that = this;

  // Fail immidately if socket is not opened
  if( !this.socketOpened ){
    //console.log('WebSocketClient : send failed - no connection');
    return false;
  }

  // and all others to new WS server
  try {
    this.connection.send(JSON.stringify(bundle));
  } catch (e) {
    //console.log('WebSocketClient : send failed ');
    console.log(e);
    return false;
  }

  return true;
};


export default WebSocketClient;